import { render, staticRenderFns } from "./ModalClose.vue?vue&type=template&id=29142629"
import script from "./ModalClose.vue?vue&type=script&lang=js"
export * from "./ModalClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports